/**
 * @generated SignedSource<<a4f3290cb50317253b288fc378b91008>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ResourceSeatReminderQuery$variables = Record<PropertyKey, never>;
export type ResourceSeatReminderQuery$data = {
  readonly billing: {
    readonly subscription: {
      readonly billingPeriodUnit: string;
    } | null | undefined;
  } | null | undefined;
  readonly current_user: {
    readonly account: {
      readonly billing_type: any;
      readonly id: number;
    };
    readonly id: number;
  } | null | undefined;
};
export type ResourceSeatReminderQuery = {
  response: ResourceSeatReminderQuery$data;
  variables: ResourceSeatReminderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "syncSubscription",
    "value": false
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billingPeriodUnit",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "users",
  "kind": "LinkedField",
  "name": "current_user",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "accounts",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "billing_type",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ResourceSeatReminderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "Billing",
        "kind": "LinkedField",
        "name": "billing",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingSubscription",
            "kind": "LinkedField",
            "name": "subscription",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "billing(syncSubscription:false)"
      },
      (v3/*: any*/)
    ],
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ResourceSeatReminderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "Billing",
        "kind": "LinkedField",
        "name": "billing",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingSubscription",
            "kind": "LinkedField",
            "name": "subscription",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "billing(syncSubscription:false)"
      },
      (v3/*: any*/)
    ]
  },
  "params": {
    "cacheID": "609faef9e714d346738e2540f084e786",
    "id": null,
    "metadata": {},
    "name": "ResourceSeatReminderQuery",
    "operationKind": "query",
    "text": "query ResourceSeatReminderQuery {\n  billing(syncSubscription: false) {\n    subscription {\n      billingPeriodUnit\n      id\n    }\n  }\n  current_user {\n    id\n    account {\n      id\n      billing_type\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "821a6ea2d62af5f6823e0ac76881e85f";

export default node;
